import script from "./Advantage.vue?vue&type=script&setup=true&lang=js"
export * from "./Advantage.vue?vue&type=script&setup=true&lang=js"

import "./Advantage.vue?vue&type=style&index=0&id=8ab69940&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ab69940"]])

export default __exports__